import SchoolMgtImage from "../assets/yue-wu-iM1coCUa5gI-unsplash.jpg";
import EcommerceImage from "../assets/agrrro-organic-5QpgBtMfidY-unsplash.jpg";
import SkillPointImage from "../assets/nick-morrison-FHnnjk1Yj7Y-unsplash.jpg";
import NisopacImage from "../assets/cdc-fx9RJgZYRUE-unsplash.jpg";
import AldeaImage from "../assets/ortopediatri-cocuk-ortopedi-akademisi-8JjW4xVwQqc-unsplash.jpg";



const projectData = [
  {
    imgsrc: EcommerceImage,
    title: "Afrobasket Express",
    text: "Discover the rich flavors of Africa with our marketplace for fresh, authentic food products. Shop from trusted vendors and enjoy convenient delivery straight to your doorstep.",
    view: "https://www.afrobasketxpress.uk/marketplace",
  },
  {
    imgsrc: SchoolMgtImage,
    title: "Scholar Flow",
    text: "A web application that helps schools manage their operations efficiently. It provides features such as student enrollment, attendance tracking, grade management, and communication tools for teachers, students, and parents.",
    view: "https://scholar-flow-nine.vercel.app/",
  },
  {
    imgsrc: SkillPointImage,
    title: "Skill Point",
    text: "A platform that connects learners with expert instructors for online courses and skill development. It offers a wide range of courses in various subjects, allowing users to enhance their knowledge and acquire new skills from the comfort of their homes.",
    view: "https://skill-point-frontend-sable.vercel.app/",
  },
  {
    imgsrc: NisopacImage,
    title: "Nisopac",
    text: "A website that provides information about the Nigerian Society of Paediatricians. It offers details about the organization's mission, services, events, and membership opportunities for professionals in the pedeatric field of medicine.",
    view: "https://nisopac.org.ng/",
  },
  {
    imgsrc: AldeaImage,
    title: "Aldea",
    text: "This is a trusted online platform that help parents find qualified pediatric providers including speech therapists, psychologists, ABA therapists, occupational therapists, and developmental specialists all in one place",
    view: "https://youraldea.com/",
  },
];

export default projectData;